import { trackButtonClick } from "@/utils/analytics";
import { getSrpLocationLabel } from "@/utils/filterTrackingService";
import { useEffect, useState } from "react";

const FilterMultiItem = ({
  panelId,
  propertyName,
  propertiesItem,
  onClick,
  selectedList = [],
  isMobView = false,
}) => {
  const [selectedItems, setSelectedItems] = useState(selectedList);

  useEffect(() => {
    document.addEventListener("click", (event) => {
      const panelBtn = document.getElementById(`${panelId}-btn`);
      const panelArea = document.getElementById(`panelBody${panelId}`);
      if (
        panelArea?.style &&
        panelBtn &&
        !panelBtn.contains(event.target) &&
        !panelArea.contains(event.target)
      ) {
        panelArea.style.display = "none";
      } else if (panelArea?.style) {
        panelArea.style.display = "block";
      }
    });
  }, []);
  const propertyCount = selectedList?.length || 0;
  let isAllChecked = true;
  const filteredList = propertiesItem.map((item, index) => {
    let isChecked = false;
    selectedItems.forEach((selectedItem) => {
      if (selectedItem.value === item.value) {
        isChecked = true;
      }
    });
    if (isChecked) {
      if (index !== 0) isAllChecked = false;
      return { ...item, isChecked: true };
    } else {
      return { ...item, isChecked: false };
    }
  });

  const onSelect = (selected) => {
    // Prevent multiple executions
    if (!window._processingStateSelection) {
      window._processingStateSelection = true;

      let flag = false;
      const newSelectedList = selectedItems.filter((selectedItem) => {
        if (selectedItem.value === selected.value) {
          flag = true;
          return false;
        }
        return selectedItem;
      });

      // Track the event only once after determining if it's a selection or deselection
      trackButtonClick({
        eventName: "filter_toggle",
        eventParams: {
          action: flag ? "deselected" : "selected",
          filter_type: "state",
        },
        eventSource: "SRP FILTERS",
        eventCategory: "NEW-SRP",
        eventLabel: `State ${flag ? "Deselected" : "Selected"}: ${selected.label} | Location: ${getSrpLocationLabel()}`,
      });

      if (!flag) {
        if (selected.value === "0000000") {
          setSelectedItems([selected]);
        } else if (
          selectedItems?.length > 0 &&
          selectedItems[0]?.value === "0000000"
        ) {
          setSelectedItems([selected]);
        } else {
          setSelectedItems([...selectedItems, selected]);
        }
      } else {
        setSelectedItems(newSelectedList);
      }

      // Reset the processing flag after a short delay
      setTimeout(() => {
        window._processingStateSelection = false;
      }, 300);
    }
  };

  return (
    <div
      className={isMobView ? "" : "list-inline-item"}
      id={panelId}
      key={`filter-item-${panelId}-${propertyName}`}
    >
      <div className="panel-group">
        <div className="panel">
          <div className="panel-heading">
            <h4 className="panel-title mb0">
              <a
                href={`#panelBody${panelId}`}
                className="selectpicker w100 show-tick form-select filter-state-menu"
                data-bs-toggle="collapse"
                data-bs-parent={`#${panelId}`}
                id={`${panelId}-btn`}
                onClick={() => {
                  // Prevent multiple executions
                  if (!window._processingStateOpen) {
                    window._processingStateOpen = true;

                    trackButtonClick({
                      eventName: "all_states_button_click",
                      eventSource: "Filter open",
                      eventCategory: "NEW-SRP",
                      eventLabel: "action:open",
                    });

                    // Reset the processing flag after a short delay
                    setTimeout(() => {
                      window._processingStateOpen = false;
                    }, 300);
                  }
                }}
              >
                <span className={`react-select__placeholder`}>
                  {propertyCount > 0 ? (
                    <span>{`${propertyCount} State`}</span>
                  ) : (
                    propertyName
                  )}
                </span>
              </a>
            </h4>
          </div>
          <div
            id={`panelBody${panelId}`}
            className={`panel-collapse collapse ${
              isMobView ? "" : "panel-model"
            }`}
            style={{ top: 65, zIndex: 11 }}
          >
            <div className="panel-body row">
              <div className="col-lg-12">
                <div style={{ display: "flex", justifyContent: "end" }}>
                  <a
                    href={""}
                    className="react-select__placeholder pl15 pr15 states-apply-btn"
                    onClick={(e) => {
                      e.preventDefault();
                      onClick(selectedItems);
                    }}
                  >
                    <span>Apply</span>
                  </a>
                </div>
                <ul className="ui_kit_checkbox selectable-list fn-400 pt10">
                  {filteredList?.map((feature, index) => {
                    return (
                      <li
                        key={`filter-option-${feature.value}`}
                        className={
                          isMobView ? "" : "checkbox-list panel-option"
                        }
                        onClick={() => onSelect(feature)}
                      >
                        <div className="form-check custom-checkbox">
                          <input
                            type="checkbox"
                            className="form-check-input mt0"
                            id={feature.label}
                            aria-label={feature.label}
                            value={feature.value}
                            checked={
                              (index === 0 && isAllChecked) ||
                              feature.isChecked ||
                              false
                            }
                            onChange={() => onSelect(feature)}
                            onClick={() => onSelect(feature)}
                          />
                          <label
                            className="form-check-label w100 checkbox-label"
                            htmlFor={feature.value}
                          >
                            {feature.label}
                          </label>
                        </div>
                      </li>
                    );
                  })}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FilterMultiItem;
